// TODO: if we have channel module remove it from here and use the channel module instead
import { IChannel } from '@/modules/notification-center/event-trigger/types/triggerTypes'
import { ModelApi } from '@/services/api/modelApi'

export class ChannelEndpoint extends ModelApi<IChannel> {
  constructor() {
    super('channel', 'notification')
  }
}
